import Button from '../Button';

export interface ITermAndConditions {
  content?: ITermAndConditionsContent;
  setShowTermsModalTnc?: React.Dispatch<React.SetStateAction<boolean>>;
  showAgreeButton?: boolean;
}

export interface ITermAndConditionsContent {
  termsAndConditionTitle?: string;
  termsAndConditionPage?: string;
}

export default function TermsModalContentServices({
  content,
  setShowTermsModalTnc,
  showAgreeButton,
}: ITermAndConditions) {
  return (
    <>
      <section
        className={`w-full overflow-auto lg:h-[calc(80vh*0.8)] container xl:px-0 ${showAgreeButton ? 'h-full' : 'h-[calc(100dvh-80px)]'} pb-20 lg:pb-0 bg-white`}
      >
        <div
          className="prose prose-li:text-xs prose-p:text-xs lg:prose-li:text-sm lg:prose-p:text-sm"
          dangerouslySetInnerHTML={{
            __html: content?.termsAndConditionPage,
          }}
        />
      </section>
      {showAgreeButton && (
        <div className="w-full bg-white py-3 fixed bottom-0 lg:static px-4">
          <Button
            onClick={() => setShowTermsModalTnc(false)}
            variant="bg-supportiveRed"
            className="w-full h-[55px] rounded"
          >
            <span className="text-[#FFFFFF] text-base font-bold uppercase lg:text-sm">Setuju</span>
          </Button>
        </div>
      )}
    </>
  );
}
